import LegalDoc from "@/components/LegalDoc";

export const PARTNER_DISCLOSURE_VERSION = "2026-08-06";

const SECTIONS = [
  {
    h: "1. What PawLinx is",
    p: [
      "PawLinx is a pet medication referral and coordination service operated by PAWLINX MED INC. We are the layer between you, your veterinarian, and a licensed pharmacy. We are not the pharmacy.",
    ],
  },
  {
    h: "2. What PawLinx is not",
    p: [
      "PawLinx is not a pharmacy. PawLinx is not a veterinary clinic. PawLinx does not employ the veterinarian who wrote your prescription and does not employ the pharmacist who fills it. PawLinx does not diagnose your pet, does not prescribe medication, and does not dispense medication. PawLinx is not an emergency service.",
    ],
  },
  {
    h: "3. Who actually fills your order",
    p: [
      "Every prescription is dispensed by a licensed pharmacy partner. Which partner fills a given order depends on the medication, the strength, the pack size, the destination, and availability. The dispensing pharmacy is subject to its own licensing, its own professional obligations, and its own policies, and those apply to your order alongside ours.",
    ],
  },
  {
    h: "4. Who reviews your prescription",
    p: [
      "Before payment opens, a licensed pharmacy technician reviews the prescription you uploaded against the quantity you requested. If your prescription does not authorize the quantity you asked for, the technician adjusts it and we explain why before you pay.",
    ],
  },
  {
    h: "5. Veterinary partners",
    p: [
      "Where a prescription needs verification, PawLinx contacts the prescribing veterinarian or clinic directly. We do not change a prescription. Only the prescriber can do that.",
    ],
  },
  {
    h: "6. Money",
    p: [
      "PawLinx earns a service margin on the medication price. That margin is already included in the price you are quoted, so there is no separate PawLinx fee added at checkout. PawLinx does not receive payment from any manufacturer to steer you toward a particular product.",
    ],
  },
  {
    h: "7. Contact",
    p: [
      "support@pawlinx.com or 1-888-827-2717, Mon to Fri 8AM to 6PM, Sat 8AM to 3PM PST.",
    ],
  },
];

export default function PartnerDisclosurePage() {
  return (
    <LegalDoc
      testid="partner-disclosure-page"
      title="Partner Disclosure"
      subtitle="PAWLINX MED INC."
      effective="6 August 2026"
      version={PARTNER_DISCLOSURE_VERSION}
      sections={SECTIONS}
    />
  );
}
